// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.log-contribution-page {
    max-width: 600px;
    margin: 0 auto;
    padding: 1rem;
}

.page-title {
    font-size: 1.75rem;
    font-weight: 700;
    color: #0f172a;
    margin: 0 0 0.25rem 0;
    letter-spacing: -0.5px;
}

.page-subtitle {
    color: #64748b;
    font-size: 0.95rem;
    margin-bottom: 2rem;
}

.error-message,
.success-message {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    border-radius: 6px;
    margin-bottom: 1.5rem;
    font-size: 0.95rem;
}

.log-contribution-page .error-message {
    background: #fee2e2;
    color: #b91c1c;
    border-left: 4px solid #b91c1c;
    justify-content: flex-start;
}

.log-contribution-page .success-message {
    background: #e6f7e6;
    color: #0b5e0b;
    border-left: 4px solid #10b981;
    justify-content: flex-start;
}

.contribution-form {
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 2rem;
}

.form-group {
    margin-bottom: 1.5rem;
}

.form-group label {
    display: block;
    margin-bottom: 0.5rem;
    font-size: 0.95rem;
    font-weight: 500;
    color: #334155;
}

.input-wrapper,
.select-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}

.input-icon {
    position: absolute;
    left: 12px;
    color: #94a3b8;
    pointer-events: none;
}

.input-wrapper input,
.select-wrapper select,
.form-group textarea {
    width: 100%;
    padding: 0.75rem 1rem 0.75rem 2.5rem;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 0.95rem;
    transition: border-color 0.2s, box-shadow 0.2s;
    background: white;
    box-sizing: border-box;
}

.form-group textarea {
    padding: 0.75rem;
    resize: vertical;
}

.input-wrapper input:focus,
.select-wrapper select:focus,
.form-group textarea:focus {
    outline: none;
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.input-wrapper input.error,
.select-wrapper select.error {
    border-color: #dc2626;
}

/* Locked amount field — when verifying a specific USER_CONFIRMED installment */
.input-wrapper input.locked {
    background: #f1f5f9;
    color: #475569;
    cursor: not-allowed;
    border-color: #cbd5e1;
}

.field-error {
    display: block;
    margin-top: 0.25rem;
    font-size: 0.85rem;
    color: #dc2626;
}

.inline-loader {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-top: 0.5rem;
    color: #64748b;
    font-size: 0.85rem;
}

/* ── Member list ── */
.member-list {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    max-height: 400px;
    overflow-y: auto;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    padding: 0.5rem;
}

/* Wraps a member row + their pending confirmations together */
.member-block {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
}

.member-item {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem;
    border: 1px solid transparent;
    border-radius: 6px;
    background: #f8fafc;
    cursor: pointer;
    transition: all 0.2s;
    width: 100%;
    text-align: left;
    flex-wrap: wrap;
}

.member-item:hover {
    background: #e2e8f0;
}

.member-item.selected {
    background: #2563eb;
    color: white;
    border-color: #1d4ed8;
}

.member-item.selected .member-remaining,
.member-item.selected .member-phone {
    color: #bfdbfe;
}

.member-name {
    flex: 1 1;
    font-weight: 500;
}

.member-phone {
    font-size: 0.82rem;
    color: #64748b;
}

.member-remaining {
    font-weight: 600;
    color: #2563eb;
    font-size: 0.88rem;
}

.winner-item {
    background: #fff4e5;
    border-color: #f59e0b;
}

.winner-item.selected {
    background: #f59e0b;
    color: white;
}

.winner-item.selected .member-remaining {
    color: white;
}

/* ── Pending confirmations per member ── */
/* These are USER_CONFIRMED installments waiting for employee verification */
.confirmation-list {
    margin-left: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
}

.confirmation-label {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 0.78rem;
    color: #64748b;
    font-weight: 500;
    margin-bottom: 0.2rem;
}

.confirmation-item {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    padding: 0.5rem 0.75rem;
    border: 1px solid #e0e7ff;
    border-radius: 6px;
    background: #f5f7ff;
    cursor: pointer;
    transition: all 0.15s;
    width: 100%;
    text-align: left;
    font-size: 0.88rem;
}

.confirmation-item:hover {
    background: #e0e7ff;
    border-color: #6366f1;
}

.confirmation-item.selected {
    background: #6366f1;
    color: white;
    border-color: #4f46e5;
}

.confirmation-item.selected .conf-mode,
.confirmation-item.selected .conf-date,
.confirmation-item.selected .conf-action {
    color: #c7d2fe;
}

.conf-amount {
    font-weight: 700;
    min-width: 80px;
}

.conf-mode {
    font-size: 0.78rem;
    color: #6366f1;
    background: #e0e7ff;
    padding: 1px 6px;
    border-radius: 4px;
}

.conf-date {
    flex: 1 1;
    font-size: 0.75rem;
    color: #94a3b8;
}

.conf-action {
    font-size: 0.78rem;
    font-weight: 600;
    color: #6366f1;
    margin-left: auto;
}

.confirmation-item.selected .conf-mode {
    background: rgba(255, 255, 255, 0.2);
    color: white;
}

/* ── Info box ── */
.info-box {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    padding: 1rem;
    margin-bottom: 1.5rem;
    font-size: 0.95rem;
    color: #334155;
}

.info-box p {
    margin: 0.25rem 0;
}

.info-box strong {
    color: #0f172a;
}

.info-header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
    font-weight: 600;
    color: #0f172a;
}

.info-details {
    font-size: 0.9rem;
    color: #334155;
    line-height: 1.6;
}

.info-details p {
    margin: 0.25rem 0;
}

/* ── Remaining hint below amount field ── */
.remaining-hint {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: 0.35rem;
    font-size: 0.82rem;
    color: #64748b;
}

/* Shown when a specific confirmation is selected for verification */
.confirmation-hint {
    color: #4f46e5;
    font-weight: 500;
}

/* ── Form actions ── */
.form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    margin-top: 2rem;
    padding-top: 1rem;
    border-top: 1px solid #e2e8f0;
}

.cancel-btn,
.submit-btn {
    padding: 0.75rem 1.5rem;
    border: none;
    border-radius: 6px;
    font-size: 0.95rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
}

.cancel-btn {
    background: white;
    border: 1px solid #e2e8f0;
    color: #64748b;
}

.cancel-btn:hover:not(:disabled) {
    background: #f8fafc;
    border-color: #94a3b8;
}

.submit-btn {
    background: #2563eb;
    color: white;
}

.submit-btn:hover:not(:disabled) {
    background: #1d4ed8;
}

.cancel-btn:disabled,
.submit-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.spinner {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

@media (max-width: 640px) {
    .contribution-form {
        padding: 1.5rem;
    }

    .form-actions {
        flex-direction: column;
    }

    .cancel-btn,
    .submit-btn {
        width: 100%;
    }

    .confirmation-item {
        flex-wrap: wrap;
    }

    .conf-date {
        order: 3;
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/employee/LogContribution.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,oBAAoB;AACxB;;AAEA;;;IAGI,WAAW;IACX,oCAAoC;IACpC,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,8CAA8C;IAC9C,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;;IAGI,aAAa;IACb,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA,+EAA+E;AAC/E;IACI,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA,8DAA8D;AAC9D;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA,2CAA2C;AAC3C,4EAA4E;AAC5E;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,YAAY;AAChB;;AAEA,mBAAmB;AACnB;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,4CAA4C;AAC5C;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA,oEAAoE;AACpE;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;;IAEI,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,QAAQ;QACR,WAAW;IACf;AACJ","sourcesContent":[".log-contribution-page {\n    max-width: 600px;\n    margin: 0 auto;\n    padding: 1rem;\n}\n\n.page-title {\n    font-size: 1.75rem;\n    font-weight: 700;\n    color: #0f172a;\n    margin: 0 0 0.25rem 0;\n    letter-spacing: -0.5px;\n}\n\n.page-subtitle {\n    color: #64748b;\n    font-size: 0.95rem;\n    margin-bottom: 2rem;\n}\n\n.error-message,\n.success-message {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.75rem 1rem;\n    border-radius: 6px;\n    margin-bottom: 1.5rem;\n    font-size: 0.95rem;\n}\n\n.log-contribution-page .error-message {\n    background: #fee2e2;\n    color: #b91c1c;\n    border-left: 4px solid #b91c1c;\n    justify-content: flex-start;\n}\n\n.log-contribution-page .success-message {\n    background: #e6f7e6;\n    color: #0b5e0b;\n    border-left: 4px solid #10b981;\n    justify-content: flex-start;\n}\n\n.contribution-form {\n    background: white;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    padding: 2rem;\n}\n\n.form-group {\n    margin-bottom: 1.5rem;\n}\n\n.form-group label {\n    display: block;\n    margin-bottom: 0.5rem;\n    font-size: 0.95rem;\n    font-weight: 500;\n    color: #334155;\n}\n\n.input-wrapper,\n.select-wrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n.input-icon {\n    position: absolute;\n    left: 12px;\n    color: #94a3b8;\n    pointer-events: none;\n}\n\n.input-wrapper input,\n.select-wrapper select,\n.form-group textarea {\n    width: 100%;\n    padding: 0.75rem 1rem 0.75rem 2.5rem;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    font-size: 0.95rem;\n    transition: border-color 0.2s, box-shadow 0.2s;\n    background: white;\n    box-sizing: border-box;\n}\n\n.form-group textarea {\n    padding: 0.75rem;\n    resize: vertical;\n}\n\n.input-wrapper input:focus,\n.select-wrapper select:focus,\n.form-group textarea:focus {\n    outline: none;\n    border-color: #2563eb;\n    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.input-wrapper input.error,\n.select-wrapper select.error {\n    border-color: #dc2626;\n}\n\n/* Locked amount field — when verifying a specific USER_CONFIRMED installment */\n.input-wrapper input.locked {\n    background: #f1f5f9;\n    color: #475569;\n    cursor: not-allowed;\n    border-color: #cbd5e1;\n}\n\n.field-error {\n    display: block;\n    margin-top: 0.25rem;\n    font-size: 0.85rem;\n    color: #dc2626;\n}\n\n.inline-loader {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin-top: 0.5rem;\n    color: #64748b;\n    font-size: 0.85rem;\n}\n\n/* ── Member list ── */\n.member-list {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n    max-height: 400px;\n    overflow-y: auto;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    padding: 0.5rem;\n}\n\n/* Wraps a member row + their pending confirmations together */\n.member-block {\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n}\n\n.member-item {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    padding: 0.75rem;\n    border: 1px solid transparent;\n    border-radius: 6px;\n    background: #f8fafc;\n    cursor: pointer;\n    transition: all 0.2s;\n    width: 100%;\n    text-align: left;\n    flex-wrap: wrap;\n}\n\n.member-item:hover {\n    background: #e2e8f0;\n}\n\n.member-item.selected {\n    background: #2563eb;\n    color: white;\n    border-color: #1d4ed8;\n}\n\n.member-item.selected .member-remaining,\n.member-item.selected .member-phone {\n    color: #bfdbfe;\n}\n\n.member-name {\n    flex: 1;\n    font-weight: 500;\n}\n\n.member-phone {\n    font-size: 0.82rem;\n    color: #64748b;\n}\n\n.member-remaining {\n    font-weight: 600;\n    color: #2563eb;\n    font-size: 0.88rem;\n}\n\n.winner-item {\n    background: #fff4e5;\n    border-color: #f59e0b;\n}\n\n.winner-item.selected {\n    background: #f59e0b;\n    color: white;\n}\n\n.winner-item.selected .member-remaining {\n    color: white;\n}\n\n/* ── Pending confirmations per member ── */\n/* These are USER_CONFIRMED installments waiting for employee verification */\n.confirmation-list {\n    margin-left: 1.5rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.3rem;\n}\n\n.confirmation-label {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    font-size: 0.78rem;\n    color: #64748b;\n    font-weight: 500;\n    margin-bottom: 0.2rem;\n}\n\n.confirmation-item {\n    display: flex;\n    align-items: center;\n    gap: 0.6rem;\n    padding: 0.5rem 0.75rem;\n    border: 1px solid #e0e7ff;\n    border-radius: 6px;\n    background: #f5f7ff;\n    cursor: pointer;\n    transition: all 0.15s;\n    width: 100%;\n    text-align: left;\n    font-size: 0.88rem;\n}\n\n.confirmation-item:hover {\n    background: #e0e7ff;\n    border-color: #6366f1;\n}\n\n.confirmation-item.selected {\n    background: #6366f1;\n    color: white;\n    border-color: #4f46e5;\n}\n\n.confirmation-item.selected .conf-mode,\n.confirmation-item.selected .conf-date,\n.confirmation-item.selected .conf-action {\n    color: #c7d2fe;\n}\n\n.conf-amount {\n    font-weight: 700;\n    min-width: 80px;\n}\n\n.conf-mode {\n    font-size: 0.78rem;\n    color: #6366f1;\n    background: #e0e7ff;\n    padding: 1px 6px;\n    border-radius: 4px;\n}\n\n.conf-date {\n    flex: 1;\n    font-size: 0.75rem;\n    color: #94a3b8;\n}\n\n.conf-action {\n    font-size: 0.78rem;\n    font-weight: 600;\n    color: #6366f1;\n    margin-left: auto;\n}\n\n.confirmation-item.selected .conf-mode {\n    background: rgba(255, 255, 255, 0.2);\n    color: white;\n}\n\n/* ── Info box ── */\n.info-box {\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    padding: 1rem;\n    margin-bottom: 1.5rem;\n    font-size: 0.95rem;\n    color: #334155;\n}\n\n.info-box p {\n    margin: 0.25rem 0;\n}\n\n.info-box strong {\n    color: #0f172a;\n}\n\n.info-header {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin-bottom: 0.5rem;\n    font-weight: 600;\n    color: #0f172a;\n}\n\n.info-details {\n    font-size: 0.9rem;\n    color: #334155;\n    line-height: 1.6;\n}\n\n.info-details p {\n    margin: 0.25rem 0;\n}\n\n/* ── Remaining hint below amount field ── */\n.remaining-hint {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    margin-top: 0.35rem;\n    font-size: 0.82rem;\n    color: #64748b;\n}\n\n/* Shown when a specific confirmation is selected for verification */\n.confirmation-hint {\n    color: #4f46e5;\n    font-weight: 500;\n}\n\n/* ── Form actions ── */\n.form-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 1rem;\n    margin-top: 2rem;\n    padding-top: 1rem;\n    border-top: 1px solid #e2e8f0;\n}\n\n.cancel-btn,\n.submit-btn {\n    padding: 0.75rem 1.5rem;\n    border: none;\n    border-radius: 6px;\n    font-size: 0.95rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n}\n\n.cancel-btn {\n    background: white;\n    border: 1px solid #e2e8f0;\n    color: #64748b;\n}\n\n.cancel-btn:hover:not(:disabled) {\n    background: #f8fafc;\n    border-color: #94a3b8;\n}\n\n.submit-btn {\n    background: #2563eb;\n    color: white;\n}\n\n.submit-btn:hover:not(:disabled) {\n    background: #1d4ed8;\n}\n\n.cancel-btn:disabled,\n.submit-btn:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.spinner {\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    from {\n        transform: rotate(0deg);\n    }\n\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n@media (max-width: 640px) {\n    .contribution-form {\n        padding: 1.5rem;\n    }\n\n    .form-actions {\n        flex-direction: column;\n    }\n\n    .cancel-btn,\n    .submit-btn {\n        width: 100%;\n    }\n\n    .confirmation-item {\n        flex-wrap: wrap;\n    }\n\n    .conf-date {\n        order: 3;\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
